/* Hooks */
import {useState, useEffect, useRef} from 'react'
import useAuth from '../../hooks/useAuth';
import useActivity from '../../hooks/useActivity';
import authFetch from '../../api/authFetch';

/* Components */
/* Top */
import Button from '../../components/Button';
import CategoryDropdownL1 from '../../components/CategoryDropdownL1';
import CategoryDropdownL2 from '../../components/CategoryDropdownL2';

/* Two major views */

/* List of cards */
import Cards from "./components/Cards";
/* Exercise view, CardExercise is general for all languages except for Norwegian and English */
import CardExercise from '../exercise/Exercise';
import AccessInterface from '../access_interface/AccessInterface';
import UserSettings from '../settings/Settings';
import CategoryDropdownStructure from './components/CategoryDropdownStructure';
import TeacherInterface from '../teacher_interface/TeacherInterface';
import SelectClass from '../select_class/SelectClass';




const Home = ({inL1, inL2}) => {
    const { auth, setAuth } = useAuth();
    const {activity, setActivity } = useActivity();
    const [L1Lang, setL1Lang] = useState(inL1)
    const [L2Lang, setL2Lang] = useState(inL2)
    const [Categories, setCategories] = useState([])
    const [L2Num, setL2Num] = useState('');
    const [L1Num, setL1Num] = useState('');
    const [CourseStructure, setCourseStructure] = useState('Category')
    const [L1L2List, setL1L2List] = useState([]);
    const [AllSounds, setAllSounds] = useState([]);
    const [adminPage, setAdmin] = useState(false);
    const [teacherPage, setTeacher] = useState(false);
    const [userSettings, setSettings] = useState(false);
    const [showExercise, setShowExercise] = useState(null);
    const [lastShownExercise, setLastShownExercise] = useState(null);
    const [message, setMessage] = useState(null)
    const [classesPage, setClasses] = useState(false);
    
    const itemsRef = useRef(null);
  
    //console.log('JOY: front page, level 0')

    function scrollToId(itemId) {
        
        const frames = [ 
            { transform: "translateX(2em)"},
            { transform: "translateX(-2em)"},
            { transform: "translateX(0)"},
      
        ]    
        const map = getMap();
        const node = map.get(itemId);
        
        if (node) {
        
        node.scrollIntoView({
            behavior: 'auto',
            block: 'start',
            inline: 'nearest'
        });

        node.animate(  
            frames ,{ duration: 1500 , fill: "forwards", iterations: 1 } 
              );
            }
       
        }
  
    function getMap() {
      if (!itemsRef.current) {
        // Initialize the Map on first usage.
        itemsRef.current = new Map();
      }
      return itemsRef.current;
    }

    const changeL1 = async (lang) => {
        setL1Lang(lang);
        if (auth?.email !== "guest") {
            const response = await authFetch(`/users/update-l1/${lang}`, {
                method: "POST"
            });
            if (response.status === 401) {
                logout();
            }
        }
    }

    const changeL2 = async (lang) => {
        setL2Lang(lang);
        if (auth?.email !== "guest") {
            const response = await authFetch(`/users/update-l2/${lang}`, {
                method: "POST"
            });
            if (response.status === 401) {
                logout();
            }
        }
    }

    

    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/list_sounds`)
            .then(response=> response.json())
            .then(json=>{    
            var products = [];
            if (json.result.length > 0) {
                for (const lang of json.result) {
                      products.push(lang.ipa.trim())
                }
            }
           
            setAllSounds(products);     
            })          
    },[]) 

    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/list_languages`)
            .then(response=>response.json())
            .then(json=>{
                
                const filtered = json.result.filter(a => a.name.trim() === L1Lang.trim())
                if (filtered.length  === 1 ) {
                    setL1Num(filtered[0].pk);
                }
                const filteredL2 = json.result.filter(a => a.name.trim() === L2Lang.trim())
                if (filteredL2.length  === 1 ) {
                    setL2Num(filteredL2[0].pk);
                }
                
            
            })          
    },[L1Lang,L2Lang]) 

    useEffect(()=>{
        
        if (auth?.email) {
        authFetch(`/stats/haloinfo/${L2Lang}/${auth.email}`, {
            method: "GET"
        })
            .then(response=>response.json())
            .then(json=>{
                var act = json
                setActivity(act)
               
               
            })     
        } 
         
      
    },[auth, L2Lang, showExercise]) 


    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/list_units/${L2Lang}/${CourseStructure}`)
            .then(response=>response.json())
            .then(json=>{
                setCategories(json)
            })          
    },[L2Lang, CourseStructure]) 


    useEffect(()=>{
        fetch(`${process.env.REACT_APP_API_URL}/?language_1_id=${L1Num}&language_2_id=${L2Num}`)
            .then(response=>response.json())
            .then(json=>{
                if (L1Num === L2Num) 
                { 
                    setL1L2List([])
                }
                else 
                {
                var products = [];
               if (json.result.length > 0) {
                    for (const lang of json.result) {
                      products.push(lang.trim())
                      }
                }
                
                setL1L2List(products);
                }
            })          
    },[L1Num,L2Num])  

    useEffect(() => {
        if (auth?.email !== "guest") {
            authFetch(`/users/get-l1`, {
                method: "GET"
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
                if (response.status === 401) {
                    logout();
                }
            }).then(json => {
                setL1Lang(json["l1"]);
            });
        }
    }, []);

    useEffect(() => {
        if (auth?.email !== "guest") {
            authFetch(`/users/get-l2`, {
                method: "GET"
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
                if (response.status === 401) {
                    logout();
                }
            }).then(json => {
                if (json) {
                    setL2Lang(json["l2"]);
                }
            });
        }
    }, []);

    const logout = () =>{
        localStorage.removeItem("token");
        setAuth({});
    }

    if (classesPage) {
        return <SelectClass successHandler={(state) => setClasses(state)} />
    }

    if (userSettings) {
        return <UserSettings successHandler={(state) => setSettings(state)} />
    }

    if (adminPage) {
        return <AccessInterface successHandler={(state) => setAdmin(state)} />
    }

    if (teacherPage) {
        return <TeacherInterface successHandler={(state) => setTeacher(state)} />
    }

    if (showExercise) {
        return <div>

                <CardExercise exercise={showExercise} l2={L2Lang} exerciseHandler={(state) =>
                                                            {
                                                                setShowExercise(state);
                                                            } }  />
            </div>
    }

    return (

                        <main className="dashboard-shell overflow-hidden md:overflow-auto">

                            {/* top */}                                                
                            <header className="dashboard-toolbar">
                               
                                {/* login user block */}   
                                
                                    <div className='toolbar-actions'>
                                        
                                            {auth?.username && (
                                                <Button text="Log out" func={logout} variant="ghost" />
                                            )}

                                            {auth?.username &&
                                                <Button
                                                    text={message ? message : auth?.username}
                                                    variant="secondary"
                                                    func={() => {
                                                        if (auth.username !== 'guest')
                                                            {setSettings(true)}
                                                        else
                                                            {setMessage('Please register!')
                                                                setTimeout(() => {setMessage(null)},1000)
                                                            }
                                                    }}
                                                />
                                            }                                        
                                       
                                            {auth?.role === "ADMIN" &&
                                                <Button
                                                    text="Admin"
                                                    variant="secondary"
                                                    func={() => setAdmin(true)}
                                                />
                                            }

                                            {["TEACHER", "ADMIN"].includes(auth?.role) &&
                                                <Button
                                                    text="Teacher"
                                                    variant="secondary"
                                                    func={() => setTeacher(true)}
                                                />
                                            }

                                            {auth?.email !== "guest" &&
                                                <Button
                                                    text="Classes"
                                                    variant="secondary"
                                                    func={() => setClasses(true)}
                                                />
                                            }
                                    </div>
                                
                            
                                <div className="toolbar-filters">
                             


                                    <div className='filter-group'>

                                        
                                        <CategoryDropdownL2 selectHandler={(event) => {
                                                                            changeL2(event.target.value);
                                                                            }}
                                                            elValue={L2Lang}/>
                                        <p className='filter-label'>
                                            Language course
                                        </p>
                                    </div>

                                    <div className='filter-group'>
                                        <CategoryDropdownL1 
                                            selectHandler={(event) => {
                                                changeL1(event.target.value);
                                            }}
                                            elValue={L1Lang}
                                        />
                                        <p className='filter-label'>
                                            Native language
                                        </p>
                                    </div>
                                    <div className='filter-group'>
                                        
                                        <CategoryDropdownStructure selectHandler={(event) => {
                                                setCourseStructure(event.target.value);
                                            }}
                                            elValue={CourseStructure}/>
                                         <p className='filter-label'>Course structure</p>

                                    </div>
                                </div>
                            </header>

                            <div className='course-layout'>
                                    <nav className='section-nav'>
                                                <p className='section-nav-title'>Sections</p>
                                                <div>
                                                    
                                                    {Categories.map(
                                                            (category,i) => 

                                                                {   
                                                            
                                                                let cat = category.split('_')[0]
                                                            
                                                                let key_value = 'index'+category
                                                                    return (
                                                                        <div
                                                                                key={key_value}
                                                                        >
                                                                        <button
                                                                                onClick={() => {scrollToId(category)}}
                                                                        >
                                                                        {cat} 
                                                                        </button>
                                                                        </div>

                                                                    )
                                                                    }
                                                    )
                                                    }
                                                </div>
                                    </nav>
                                    <section className='course-content'>
                                        
                                        
                                        
                                            
                                        
                                            {Categories.map(
                                                (category,i) => 
                                                    {   
                                                        
                                                        return (
                                                            <div    key={category} 
                                                                    ref={(node) => {
                                                                        const map = getMap();
                                                                        if (node) {
                                                                        map.set(category, node);
                                                                        } else {
                                                                        map.delete(category);
                                                                        }
                                                                    }}
                                                            >                   
                                                                
                                                                
                                                                    
                                                                    <Cards  L1L2List={L1L2List} 
                                                                            L2Lang={L2Lang} 
                                                                            AllSounds={AllSounds} 
                                                                            unit={category} 
                                                                            units={CourseStructure}
                                                                            exerciseHandler={(state) =>
                                                                                {
                                                                                    setShowExercise(state);
                                                                                    setLastShownExercise(state);
                                                                                } }
                                                                            focusId={lastShownExercise ? 
                                                                                (lastShownExercise[CourseStructure] === category) ? category+'_'+lastShownExercise.Group_lesson : null
                                                                                : null  
                                                                        
                                                                            }
                                                                    /> 
                                                                
                                                            </div>
                                                        );
                                                    }
                                                )
                                            }        
                                    </section>
                            </div>
                        </main>
    )
}

export default Home;
